/**
 * Ficha do aluno — mobile: página dedicada. Desktop: redireciona para lista + modal.
 */
import { useState, useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { User } from 'lucide-react';
import { MobilePageWrapper } from '../../components/layout/MobilePageWrapper';
import { MobileProfessorAlunoPainel } from './MobileProfessorAlunoPainel';

function useIsMobile(bp = 768) {
  const [m, setM] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth < bp : false,
  );
  useEffect(() => {
    const h = () => setM(window.innerWidth < bp);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, [bp]);
  return m;
}

export function ProfessorAlunoFichaPage() {
  const { id } = useParams<{ id: string }>();
  const isMobile = useIsMobile();

  if (!isMobile && id) {
    return <Navigate to="/professor/alunos" replace state={{ fichaId: id }} />;
  }

  if (!id) {
    return <Navigate to="/professor/alunos" replace />;
  }

  return (
    <MobilePageWrapper
      title="Ficha do Aluno"
      icon={User}
      iconColor="#93c5fd"
      backTo="/professor/alunos"
      mobileOnly
    >
      <MobileProfessorAlunoPainel alunoId={id} />
    </MobilePageWrapper>
  );
}
